export default (key, data) =>
  new Promise((resolve, reject) => {
    window.axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}settings/admin/${key}`, {
        key: key,
        setting: data,
      })
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
